// Growth OS sections, in the spec's order. `group: 'system'` sits below a
// divider in the sidebar, as in the spec's mockup. The slug is the URL segment under
// /admin2/growth; the first one is the landing page. Arabic-only by owner
// decision (2026-11-01): Growth OS is an internal owner tool.
export const GROWTH_SECTIONS = [
  { slug: 'dashboard',     ar: 'لوحة التحكم',       icon: 'grid' },
  { slug: 'campaigns',     ar: 'إدارة الحملات',      icon: 'megaphone' },
  { slug: 'journey',       ar: 'رحلة العميل',        icon: 'route' },
  { slug: 'products',      ar: 'المنتجات',           icon: 'box' },
  { slug: 'behavior',      ar: 'تحليل السلوك',       icon: 'pointer' },
  { slug: 'sessions',      ar: 'سجل الجلسات',        icon: 'list' },
  { slug: 'experiments',   ar: 'التجارب (A/B)',      icon: 'flask' },
  { slug: 'profitability', ar: 'الربحية',            icon: 'coins' },
  { slug: 'ai-manager',    ar: 'مدير النمو الذكي',   icon: 'spark' },
  { slug: 'context',       ar: 'وضع معبر',          icon: 'book' },
  { slug: 'deals',         ar: 'الصفقات خارج التطبيق', icon: 'handshake' },
  { slug: 'approvals',     ar: 'مركز الموافقات',     icon: 'check' },
  { slug: 'reports',       ar: 'التقارير',           icon: 'doc', group: 'system' },
  { slug: 'integrations',  ar: 'التكاملات',          icon: 'plug', group: 'system' },
  { slug: 'settings',      ar: 'الإعدادات',          icon: 'gear', group: 'system' },
];

export const growthPath = (slug) => (slug === 'dashboard' ? '/admin2/growth' : `/admin2/growth/${slug}`);
export const findGrowthSection = (slug) => GROWTH_SECTIONS.find((s) => s.slug === (slug || 'dashboard'));
